<table mat-table [dataSource]="deliveries" (keydown)="onTableKeyDown($event)"
       class="mat-elevation-z8 w-full" aria-label="Tabelle mit Update-Terminen" role="grid" tabindex="-1">
  <ng-container matColumnDef="deliveryDate">
    <th mat-header-cell *matHeaderCellDef [id]="'deliveryDateId' + breakPointExtension + ' ' + categoryName" class="!pl-6 min-w-[10rem]">
      {{ 'delivery-all-items.provision_date' | translate }}
    </th>
    <td mat-cell role="rowheader" *matCellDef="let element" class="!pl-6" [ngClass]="{'font-semibold': (element.deliveryType === DeliveryType.MainRelease ||
        element.deliveryType === DeliveryType.CompactRelease)}">
      @if (element.totalProducts > 0 && element.deliveryType !== DeliveryType.CompactRelease) {
        <a
          [routerLink]="element.routerLink"
          [id]="'a_' + breakPointExtension + element.id"
          [attr.aria-label]="(element.deliveryDate | date:'dd.MM.yyyy') + ' (' + element.deliveryName + ')'"
          myupdatesFocusableTableItem
          (keydown)="onLinkKeyDown($event)"
          class="outline-none"
        >
          {{ element.deliveryDate | date:'dd.MM.yyyy' }}
          @if (!platform.SAFARI) {
            <span class="absolute inset-0 z-[2]"></span>
          }
        </a>
      } @else {
        {{ element.deliveryDate | date:'dd.MM.yyyy' }}
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="deliveryDescription">
    <th mat-header-cell *matHeaderCellDef [id]="'deliveryDescriptionId' + breakPointExtension + ' ' + categoryName">
      {{ 'delivery-all-items.update_description' | translate }}
    </th>
    <td mat-cell class="text-base" *matCellDef="let element" [ngClass]="{'font-semibold': (element.deliveryType === DeliveryType.MainRelease ||
        element.deliveryType === DeliveryType.CompactRelease)}">
      {{ element.deliveryName }}</td>
  </ng-container>
  <ng-container matColumnDef="totalProducts">
    <th mat-header-cell *matHeaderCellDef [id]="'totalProductsId' + breakPointExtension + ' ' + categoryName">
      {{ 'delivery-all-items.total_programs' | translate }}</th>
    <td mat-cell class="text-base" *matCellDef="let element" [ngClass]="{'font-semibold': (element.deliveryType === DeliveryType.MainRelease ||
        element.deliveryTyp === DeliveryType.CompactRelease)}">
      {{ element | numberProducts }}
    </td>
  </ng-container>
  <ng-container matColumnDef="deliveryLink">
    <th mat-header-cell *matHeaderCellDef [id]="'deliveryLinkId' + breakPointExtension + ' ' + categoryName" class="!pr-10" aria-label="Aktion"></th>
    <td mat-cell *matCellDef="let element" class="!pr-10">
      @if (element.totalProducts > 0 && element.deliveryType !== DeliveryType.CompactRelease) {
        <div class="flex items-center flex-nowrap justify-end">
          <mat-icon svgIcon="sli-pfeil-rechts-20" aria-label="Details zum Update-Termin anzeigen"></mat-icon>
        </div>
      }
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"
      class="!h-18 focus-within:outline focus-within:outline-2 focus-within:outline-blue-500 focus-within:outline-offset-[-2px]"
      [ngClass]="{'relative': !platform.SAFARI, 'cursor-pointer': (row.totalProducts > 0 && row.deliveryType !== DeliveryType.CompactRelease)}"
        [attr.aria-selected]="selectedDelivery?.id === row.id"
  ></tr>
</table>
